<script setup lang="ts">
  import { provide, useTemplateRef } from 'vue'
  import {
    stakeholderModalsKey,
    type ShowStakeholderUpdateGeneralInfoParams,
    type ShowStakeholderUpdatePostAddressParams,
    type ShowStakeholderUpdateVisitAddressParams,
    type ShowStakeholderUpdateBillingAddressParams,
    type ShowStakeholderUpdateBillingDetailsParams,
    type ShowStakeholderUpdateInternalIdentificationNumbersParams,
    type ShowStakeholderUpdateOfficialBusinessNumbersParams
  } from './stakeholder-modals'
  import StakeholderModalUpdateGeneralInfo from '../modals/StakeholderModalUpdateGeneralInfo.vue'
  import StakeholderModalUpdatePostAddress from '../modals/StakeholderModalUpdatePostAddress.vue'
  import StakeholderModalUpdateVisitAddress from '../modals/StakeholderModalUpdateVisitAddress.vue'
  import StakeholderModalUpdateBillingAddress from '../modals/StakeholderModalUpdateBillingAddress.vue'
  import StakeholderModalUpdateBillingDetails from '../modals/StakeholderModalUpdateBillingDetails.vue'
  import StakeholderModalUpdateInternalIdentificationNumbers from '../modals/StakeholderModalUpdateInternalIdentificationNumbers.vue'
  import StakeholderModalUpdateOfficialBusinessNumbers from '../modals/StakeholderModalUpdateOfficialBusinessNumbers.vue'

  const modalUpdateGeneralInfo = useTemplateRef('modal-update-general-info')
  const modalUpdatePostAddress = useTemplateRef('modal-update-post-address')
  const modalUpdateVisitAddress = useTemplateRef('modal-update-visit-address')
  const modalUpdateBillingAddress = useTemplateRef(
    'modal-update-billing-address'
  )
  const modalUpdateBillingDetails = useTemplateRef(
    'modal-update-billing-details'
  )
  const modalUpdateInternalIdentificationNumbers = useTemplateRef(
    'modal-update-internal-identification-numbers'
  )
  const modalUpdateOfficialBusinessNumbers = useTemplateRef(
    'modal-update-official-business-numbers'
  )

  provide(stakeholderModalsKey, {
    showUpdateGeneralInfo: (params: ShowStakeholderUpdateGeneralInfoParams) => {
      modalUpdateGeneralInfo.value?.showModal(params)
    },
    showUpdatePostAddress: (params: ShowStakeholderUpdatePostAddressParams) => {
      modalUpdatePostAddress.value?.showModal(params)
    },
    showUpdateVisitAddress: (
      params: ShowStakeholderUpdateVisitAddressParams
    ) => {
      modalUpdateVisitAddress.value?.showModal(params)
    },
    showUpdateBillingAddress: (
      params: ShowStakeholderUpdateBillingAddressParams
    ) => {
      modalUpdateBillingAddress.value?.showModal(params)
    },
    showUpdateBillingDetails: (
      params: ShowStakeholderUpdateBillingDetailsParams
    ) => {
      modalUpdateBillingDetails.value?.showModal(params)
    },
    showUpdateInternalIdentificationNumbers: (
      params: ShowStakeholderUpdateInternalIdentificationNumbersParams
    ) => {
      modalUpdateInternalIdentificationNumbers.value?.showModal(params)
    },
    showUpdateOfficialBusinessNumbers: (
      params: ShowStakeholderUpdateOfficialBusinessNumbersParams
    ) => {
      modalUpdateOfficialBusinessNumbers.value?.showModal(params)
    }
  })
</script>

<template>
  <slot />
  <StakeholderModalUpdateGeneralInfo ref="modal-update-general-info" />
  <StakeholderModalUpdatePostAddress ref="modal-update-post-address" />
  <StakeholderModalUpdateVisitAddress ref="modal-update-visit-address" />
  <StakeholderModalUpdateBillingAddress ref="modal-update-billing-address" />
  <StakeholderModalUpdateBillingDetails ref="modal-update-billing-details" />
  <StakeholderModalUpdateInternalIdentificationNumbers
    ref="modal-update-internal-identification-numbers"
  />
  <StakeholderModalUpdateOfficialBusinessNumbers
    ref="modal-update-official-business-numbers"
  />
</template>
